
import React from "react";
import Footer from "./shared/Footer";
import { i18nManager } from "../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Button, PopoverManageRef } from "@ronuse/noseur";
import { Debugger, CacheManager, Utils, Schemes } from "../utils";
import { FeatureFlagEvent, useFeatureFlags } from "@syllektis/oya-gbewa-react";
import { IPlatform, IProfile, PlatformService, SanitizedResponse } from "../services";

function Landing() {
    const platformService = PlatformService.getInstance();
    const settingButton = React.useRef<HTMLButtonElement>(null);
    const [platforms, setPlatforms] = React.useState<IPlatform[]>();
    const profilePopOverManageRef = React.useRef<PopoverManageRef>(null);
    const profile = CacheManager.get(CacheManager.PROFILE_KEY) as IProfile;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const { allowUserTicketManagement } = useFeatureFlags({
        registerEvents: [FeatureFlagEvent.CHANGE],
        query: { platform: "rivtn" },
        flags: {
            allowUserTicketManagement: { id: "allow-user-ticket-management", initialValue: false },
        },
    });

    React.useEffect(() => {
        if (!searchParams.has("pas")) return;
        Utils.processSigninData(searchParams.get("pas")!, () => {
            searchParams.delete("pas");
            setSearchParams(searchParams);
        });
    }, []);

    React.useEffect(() => {
        platformService.getPlatforms().then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("Landing:useEffect:getPlatforms", apiResponse.data);
            setPlatforms(apiResponse.data! as any[]);
        }).catch(Utils.reportError);

        // use use effect to remove styles
        Utils.loadStyle(`
            body {
                --platformColor: #4D1579;
                --platformColorRgb: 77, 21, 121;
            }  
        `);
    }, []);

    return (<div className="support home">
        <div className="header">
            <div className="menubar">
                <a className="left" href={`/`} >
                    <img src={i18nManager.Labels.logo} alt={`${i18nManager.Labels.name} Support`} />
                    <div className="logo">{i18nManager.Labels.name}</div>
                </a>
                {(allowUserTicketManagement) && (<div className="right">
                    {Utils.buildProfileDropdown("", profile, settingButton, profilePopOverManageRef, i18nManager.Labels.header)}
                    {!profile?.email ? <Button onClick={Utils.signIn} text={i18nManager.Labels.header.login} scheme={Schemes.RIVTN_HERA} style={{ padding: "10px 30px", marginRight: 10, minWidth: 50 }} /> : null}
                </div>)}
            </div>
            <div className="hero">
                <div>
                    <div className="center" style={{ marginBottom: "10%" }}>
                        <span className="t">{i18nManager.Labels.welcome_title}</span>
                        <span className="d" style={{ marginTop: 10 }}>{i18nManager.Labels.welcome_content}</span>
                    </div>
                </div>
            </div>
        </div>
        <div className="platforms">
            {(!platforms) && (<div style={{ margin: "10%" }}>{Utils.LOADING_STATE}</div>)}
            {platforms?.map((platform) => (<ReactRouterDom.NavLink key={platform.slug} to={`/${platform.slug}`} className="platform">
                <img src={platform.logo_url ?? i18nManager.Labels.logo} alt={platform.slug} />
                <span>{platform.name}</span>
            </ReactRouterDom.NavLink>))}
        </div>
        <Footer />
    </div>);
}

export default Landing;
